// Actions
export var SET_CONNECTED_USER = "SET_CONNECTED_USER"; // Statut initial

export var INITIAL_STATE = {
  user: null
};